// core
import { Injectable } from '@angular/core';
import { Event, RouterEvent, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

// material
import { MatDialog } from '@campfire-nx/material';

// components
import { EmailQuoteInterstitialComponent } from '../components/interstitials/email-quote-interstitial/email-quote-interstitial.component';
import { DefaultInterstitialComponent } from '../components/interstitials/default-interstitial/default-interstitial.component';
import { RaptorMedicalInterstitialComponent } from '../components/interstitials/raptor-medical-interstitial/raptor-medical-interstitial.component';
import { AnimatedTransitionInterstitialComponent } from '../components/interstitials/animated-transition-interstitial/animated-transition-interstitial.component';

@Injectable()
export class RaptorInterstitialService {

  intersitialConfig = {
    position: { top: '0', left: '0' },
    height: '100%',
    width: '100%',
    maxWidth: '100%',
    closeOnNavigation: true,
    hasBackdrop: false
  };
  popupConfig = {
    position: { top: '0' },
    maxWidth: '100%',
    closeOnNavigation: true,
    hasBackdrop: true
  };

  dialogRef: any = null;
  startTime: any = null;
  endTime: any = null;
  interstitialTime: any = null;

  constructor(public dialog: MatDialog, private router: Router) {
    this.router.events
      .pipe(filter((e: Event | RouterEvent): e is RouterEvent => e instanceof NavigationEnd))
      .subscribe((e: RouterEvent) => {
        if (this.dialogRef) {
          this.dialogRef.close();
        }

        this.startTime = null;
        this.endTime = null;
        this.interstitialTime = null;
      });
  }

  public open(interstitialDetails: any) {
    this.startTime = new Date().getTime();

    this.interstitialTime = (
      interstitialDetails.settings &&
      interstitialDetails.settings.time &&
      parseInt(interstitialDetails.settings.time)
      ) || 4000;

    if (interstitialDetails.type === 'animated-transition') {
      this.dialogRef = this.dialog.open(AnimatedTransitionInterstitialComponent,
        {
          ...this.intersitialConfig,
          panelClass: ['animated-transition-interstitial-container'],
          data: {...interstitialDetails, time: this.interstitialTime}
        }
      );
    } else {
      this.dialogRef = this.dialog.open(DefaultInterstitialComponent,
        {
          ...this.intersitialConfig,
          panelClass: ['default-interstitial-container'],
          data: {...interstitialDetails, time: this.interstitialTime}
        }
      );
    }
  }

  public openActionInterstitial(actionInterstitialDetails: any) {
    if (
      actionInterstitialDetails &&
      actionInterstitialDetails.settings &&
      actionInterstitialDetails.settings.action === 'email_quote'
    ) {
      this.dialogRef = this.dialog.open(
        EmailQuoteInterstitialComponent,
        {
          ...this.popupConfig,
          panelClass: ['dialog-large'],
          data: actionInterstitialDetails
        }
      );
    }
  }

  public openMedicalInterstitial(form: any, question: any) {
    this.dialogRef = this.dialog.open(
      RaptorMedicalInterstitialComponent,
      {
        ...this.popupConfig,
        panelClass: ['dialog-verisk'],
        data: {
          form: form,
          question: question
        }
      }
    );
  }

  public close(callback?: () => void): void {
    let closeTime = 0;

    if (this.startTime && this.interstitialTime) {
      this.endTime = new Date().getTime();
      const currentCounter = this.interstitialTime - (this.endTime - this.startTime);
      if (currentCounter > 0) {
        closeTime = currentCounter;
      }
    }

    setTimeout(() => {
      // If there is redirection callback we do not want the interstitial to close
      //  as that shows next step before redirection which is not intentional
      if (callback) {
        callback();
      } else if (this.dialogRef) {
        this.dialogRef.close();
      }

      this.startTime = null;
      this.endTime = null;
      this.interstitialTime = null;
    }, closeTime);
  }
}
